import { ActionTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyDescriptionTypesStore from "./property-description-types.store";
import { IPropertyPictureModel } from "../../../../models/property";
import { IListing } from "../../../../models/listing-base-model";

const descriptionActions = <ActionTree<IPropertyEditState, any>>{
	[propertyDescriptionTypesStore.Get.LIST_OF_PROPERTY_DESCRIPTIONS]: (
		{ getters, commit },
		param: number
	) => {
		return getters.service[
			propertyDescriptionTypesStore.Service.LIST_OF_PROPERTY_DESCRIPTIONS
		](param)
			.then((listingResult: IListing<IPropertyPictureModel>) => {
				commit(
					propertyDescriptionTypesStore.Set.LIST_OF_PROPERTY_DESCRIPTIONS,
					listingResult
				);
				return Promise.resolve(listingResult);
			})
			.catch(error => Promise.reject(error));
	},
};

export default descriptionActions;
